<template>
  <div style="font-family: sans-serif;">
    <v-card class="login" :class="mobil? 'pa-20': 'pa-40'">
      <form>
      <v-layout row wrap>
        <v-flex xs5 sm6>
          <img src="@/assets/logo-bhp.png" class="logo">
        </v-flex>
        <v-flex xs6 sm5 offset-sm1 offset-xs1>
          <img src="@/assets/logo-escondida.png" class="logo" style="margin-top: 5px">
        </v-flex>
      </v-layout>
      <h1 class="title">Activos Críticos</h1>
      <br>
      <v-text-field placeholder="Ingrese Usuario"
        tabindex="1"
        :class="!credentials.username && 'textEmpty'"
        clearable prepend-icon="edit" 
        v-on:keyup.enter="focusPass"
        v-model="credentials.username"/>
      <br>
      <v-text-field placeholder="Ingrese contraseña"
        tabindex="2"
        :class="!credentials.password && 'textEmpty'"
        clearable prepend-icon="edit" 
        v-on:keyup.enter="submit"
        v-model="credentials.password" type="password"/>
      <br>   
      <v-btn color="primary" @click="submit" class="button">
        <v-icon>account-key</v-icon>
        <span>Iniciar sesión</span>
      </v-btn>
      </form>
    </v-card>
    <v-dialog v-model="dialog" :width="'600px'">
			<v-card class="fullHeight pa-20 textAlignCenter">
				<h2>Ingresar correo electronico</h2>
				<br>
        <p>
          Es necesario que sea ingresado su correo antes de acceder.
        </p>
				<v-text-field placeholder=" Ingrese Email" :class="!email && 'textEmpty'" clearable prepend-icon="edit" v-model="email"/>
				<div>
					<v-btn @click="dialog = false" color="secondary">
						<fs1-span>Cancelar</fs1-span>
					</v-btn>
					<v-btn @click="addEmail" color="primary">
						<fs1-span>Aceptar</fs1-span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { login, getAccess, editUser } from '@/requests/ac';
import { ENDPOINT_TOKEN } from '../config';

export default {
  name: 'Login',
  data() {
    return {
      credentials: {
        username:'',
        password:'',
      },
      user: {},
      dialog: false,
      email: '',
    }
  },
  computed: {
    session() { return this.$store.getters.session }
  },
  async created() {
    const a = await getAccess(true); // no se mostrara nada hsata que esto termine
    if (a) {
      // si llego a la pagina del login(esta) y ya estaba logeado, verificar y enviar a home
      const {access} = a;
      const { employee_name, key_position_name, position_name } = a.user;
      this.$store.dispatch('set',{key:'session', val:{access, employee_name, key_position_name, position_name }});
      this.$router.push({ name: 'home'});
    } // if
  },
  methods: {
    focusPass(event) {
      document.getElementById('pass').focus();
    },
    submit() {
      //jofrp
      if(this.credentials.username === '') {
        this.setSnackbar({message:'Datos incorrectos...', class:'error'});
        return;
      } // if

      this.setProgress({show:true,message:'verificando...'});
      // obtener token
      axios.post(ENDPOINT_TOKEN, this.credentials)
        .then(r => r.data)
        .then(data => {
          this.setProgress({show:false});
          
          data && data.access
            ? this.login(data)
            : this.setSnackbar({message:'Datos incorrectos...', class:'error'});
        })
        .catch(e => {
          if (e.response && e.response.status === 401) {
            this.setProgress({show:false});
            this.setSnackbar({message:'Datos incorrectos...', class:'error'});
            return;
          }
          this.getError(e)
        });
    }, // submit
    login({refresh, access, user}) {
      this.$store.dispatch('assign',{key:'access', val:{time:new Date().getTime(),status:1,val:access}});
      this.$store.dispatch('set',{key:'session', val:{refresh,access, user }});
      login(refresh);
      if (!user.email) {
        this.user = user;
        this.dialog = true;
      } else {
        this.$nextTick(() => this.$router.push({ name: 'home'}) );
      } // if
    }, // login
    addEmail() {
      this.setProgress({show:true,message:'Guardando...'});
      this.user.email = this.email;
      
      editUser(this.user)
        .then(r => {
          this.setProgress({show:false});
          if(r && r.id) {
            this.setSnackbar({message:'Guardado.',class:'success'});
            this.$router.push({ name: 'home'});
          } else {
            this.setSnackbar({message:'Ocurrió un problema.',class:'error'});
          } // if
        })
        .catch(e => this.getError(e));
    }, // addEmail
  },
};
</script>

<style scoped>
.login {
  padding: 50px 50px 40px 50px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  max-width: 400px;
  border: 2px solid #ccc !important;
  margin: 0 auto;
  margin-top: 80px;
}

.title {
  color: rgb(246, 123, 47);
  font-weight: bold;
  font-size: 25px;
  margin-top: 30px;
  margin-bottom: 10px;
}

.logo {
  max-width: 100%;
}

.button {
  background: rgb(246, 123, 47) !important;
  width: 100%;
}

@media (max-width: 768px) {
  .login {
    border: none;
    margin-top: 40px;
    margin-right: 10px;
    margin-left: 10px;
    position: static;
    padding: 30px 30px 20px 30px;
  }
}
</style>
